import { IComponentOptions, IPromise, IScope } from "angular";
import { IModalComponent } from "@gtmhub/core/routing";
import { AssigneeActions, IAssignee, IAssigneesStoreState } from "@gtmhub/assignees";
import { getFilteredAssigneesRedux } from "@gtmhub/assignees/redux/assignee-selectors";
import { INgRedux } from "@gtmhub/state-management";
import { GtmhubController } from "@gtmhub/core";
import { UserSelectorEvents } from "../user-selector/user-selector.events";
import { IModalService } from "angular-ui-bootstrap";

interface IOwnersSelectorComponentBindingsResolve {
  previouslySelectedIds: string[];
}

interface IOwnersSelectorComponentRedux {
  assignees: IAssignee[];
}

const bindStateToCtrl = (state: IAssigneesStoreState): IOwnersSelectorComponentRedux => {
  return {
    assignees: getFilteredAssigneesRedux({
      assignees: state.assignees.items,
      assigneeName: "",
      assigneeType: "both",
      limit: 500,
    }),
  };
};

/* eslint-disable @typescript-eslint/no-empty-interface */
export interface IOwnersSelectorComponentBindings extends IModalComponent<IOwnersSelectorComponentBindingsResolve> {}
export interface OwnersSelectorComponentCtrl extends IOwnersSelectorComponentBindings, IOwnersSelectorComponentRedux {}
export class OwnersSelectorComponentCtrl extends GtmhubController {
  selectedOwnerIds: string[];

  private userSelectorEvents: UserSelectorEvents;

  static $inject = ["$scope", "$ngRedux", "AssigneeActions"];

  constructor(private $scope: IScope, $ngRedux: INgRedux, assigneeActions: AssigneeActions) {
    super();
    this.userSelectorEvents = new UserSelectorEvents(this.$scope);
    this.onDestroy($ngRedux.connect(bindStateToCtrl)(this));
    $ngRedux.dispatch(assigneeActions.getAssignees());
  }

  $onInit(): void {
    this.selectedOwnerIds = angular.copy(this.resolve.previouslySelectedIds || []);
  }

  updateOwners(): void {
    this.close({ $value: this.selectedOwnerIds });
  }

  updateSelectedOwners(ids: string[]): void {
    this.selectedOwnerIds = ids;
  }

  toggleUserInSelection(id: string) {
    const index = this.selectedOwnerIds.indexOf(id);

    if (index === -1) {
      this.selectedOwnerIds.push(id);
    } else {
      this.selectedOwnerIds.splice(index, 1);
    }

    this.userSelectorEvents.broadcastChangeSelectedUsers(this.selectedOwnerIds);
  }
}

export class OwnersSelectorModalService {
  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  open(previouslySelectedIds: string[]): IPromise<string[]> {
    return this.$uibModal.open({
      component: "owners-selector",
      resolve: {
        previouslySelectedIds: () => previouslySelectedIds,
      },
      backdrop: true,
      windowClass: "owners-selector",
    }).result;
  }
}

export const OwnersSelectorComponent: IComponentOptions = {
  templateUrl: require("./owners-selector.jade"),
  controller: OwnersSelectorComponentCtrl,
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
